import { DialogDescription } from '@talentmesh/ui/components/dialog';
import UIStrings from '@/Utils/UIStrings';

const AssessmentResetDialogBody = () => {
    return (
        <DialogDescription asChild>
            <div className="text-foreground flex flex-col gap-4">
                <p className="text-base">{UIStrings.Important}</p>
                <ul className="text-foreground list-disc space-y-2 pl-5 text-sm leading-relaxed">
                    {UIStrings.getAssessmentResetDialogWarningList.map((warning: string) => (
                        <li key={warning}>{warning}</li>
                    ))}
                </ul>
            </div>
        </DialogDescription>
    );
};

export default AssessmentResetDialogBody;
